import Sidebar from "../components/Sidebar";
import AssistantBubble from "../components/assistant/AssistantBubble";

const Root = ({ children }) => {
  const containerStyle = {
    marginLeft: "var(--sidebar-width, 256px)",
    width: "calc(100% - var(--sidebar-width, 256px))",
  };

  return (
    <>
      <Sidebar />
      <div className="px-4 pt-4 pb-10 app-container" style={containerStyle}>
        {children}
        <div className="white-container"></div>
      </div>
      {/* fora do container que rola: a bolha e a conversa ficam fixas */}
      <AssistantBubble />
    </>
  );
};

export default Root;
